export default "__VITE_ASSET__6c5a1702__"